import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiCheckCircle, FiMail } from "react-icons/fi";
import { MdOutlineArrowForward } from "react-icons/md";
import { AWS_CLOUD_FRONT_URL } from "../lib/constants";

const SignupSuccess: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="h-screen flex flex-row">
      {/* Left Container */}
      <div className="md:w-1/2 w-full mx-8 md:min-h-screen max-h-screen bg-white xxxl:py-24 py-10 xxxl:px-[16.5rem] xxl:px-52 xl:px-28 lg:px-20 md:px-8 px-10 overflow-y-auto">
        <div className="mb-8 mt-10">
          <img
            className="w-[200px] h-[52px] text-black hover:cursor-pointer"
            src={`${AWS_CLOUD_FRONT_URL}/AfroCart_Logo_Black.png`}
            alt="logo"
            onClick={() => navigate("/")}
          />

          <h1 className="text-2xl text-black font-helveticaBold xxxl:mt-24 mt-10 font-bold">
            Thank you for signing up!
          </h1>
          <p className="xxxl:text-base text-sm font-normal text-customGrayBase xxxl:mt-6 mt-2">
            Your account is currently under review. We’re excited to welcome you
            to the Afrocart community! Our team is diligently reviewing your
            information to ensure everything is in order.
          </p>
        </div>
        <div className="mt-2">
          <div className="mb-4">
            <h4 className="xxxl:text-base font-helveticaBold text-1xl font-normal text-customGrayDark">
              What happens next?
            </h4>
          </div>
          <div className="mt-4">
            <div className="flex items-start space-x-3 xxxl:text-base text-sm">
              <FiCheckCircle size={20} className="text-customGreenColor mt-1" />
              <div>
                <h2 className="font-helveticaBold tracking-wide text-customGrayDark">
                  Account Review:
                </h2>
                <h2 className="text-customGrayDark">
                  Our team will verify your account details.
                </h2>
              </div>
            </div>

            <div className="flex items-start space-x-3 xxxl:text-base text-sm mt-5">
              <FiMail size={20} className="text-customGreenColor mt-1" />
              <div>
                <h2 className="font-helveticaBold tracking-wide text-customGrayDark">
                  Approval Notification:
                </h2>
                <p className="text-customGrayDark">
                  You will receive an email confirmation once your account has
                  been approved.
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-start space-x-3 xxxl:mt-8 mt-6 font-normal xxxl:text-base text-sm text-customGrayBase">
            <div>
              We appreciate your patience and will notify you as soon as your
              account is active. In the meantime, feel free to explore our{" "}
              <Link
                to="/contact-support"
                target="_self"
                className="text-customGreenColor font-helveticaBold"
              >
                Contact Support
              </Link>{" "}
              if you have any questions.
            </div>
          </div>
        </div>
        <button
          onClick={() => navigate("/vendor-login")}
          className="flex justify-center items-center w-full bg-customGreenColor text-white font-helveticaMedium text-sm border rounded-md mt-6 py-2 px-3"
        >
          Sign in
          <MdOutlineArrowForward className="ml-2" />
        </button>

        <div className="mt-6 xxxl:mt-12 mt-2 text-xs text-customGrayBase">
          By signing up, you agree to our{" "}
          <Link
            to="/terms-of-use"
            target="_self"
            className="text-customGreenColor font-helveticaBold underline"
          >
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link
            to="/privacy-policy"
            target="_self"
            className="text-customGreenColor font-helveticaBold underline"
          >
            Privacy Policy
          </Link>
          , including{" "}
          <Link
            to="/cookie-use"
            target="_self"
            className="text-customGreenColor font-helveticaBold underline"
          >
            cookie use.
          </Link>
        </div>
      </div>

      {/* Right Container */}
      <div className="w-full md:w-1/2 md:flex hidden items-center justify-center bg-white p-6 pt-4 min-h-screen">
        <div className="w-full h-full flex flex-col items-center justify-center bg-customBgGray border rounded-lg">
          <img
            src="/gridImg.JPG"
            alt="Sample img"
            className="object-fill shadow-2xl xxxl:h-96 xl:h-72 lg:h-48 h-44 mt-10 border-2 border-black rounded-lg relative xxxl:bottom-20 bottom-8"
          />
          <div className="flex flex-col items-center mt-2 justify-center text-center xxxl:px-52 xxl:px-24 lg:px-20 md:px-8">
            <p className="text-2xl font-helveticaBold font-bold">
              Start Your Journey as a Vendor
            </p>
            <h4 className="mt-6 text-sm text-balance text-customGrayBase">
              Create your Afrocart account to easily manage your store, add
              products, track sales, and connect with customers. This form is
              for retailers only.
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupSuccess;
